module.exports = __webpack_public_path__ + "img/header_1_grey.48b11caa.svg";